/** Typed presentation for the single approved Expedia case analysis, not a second body or FAQ owner. */
export const EXPEDIA_EXACT_SLUG = "expedia-ai-disintermediation-agentic-commerce-2026";
export const isExpediaExactArticle = (slug: string) => slug === EXPEDIA_EXACT_SLUG;
export const EXPEDIA_PRESENTATION: { faqIntroduction: string; commissioningContent: string; aliases: Record<string, readonly string[]>; cta: { heading: string; body: string; button: string; url: string } } = {
  "faqIntroduction": "These answers distinguish possible changes in travel distribution from capabilities that must be verified in a specific product. Use the Expedia case to ask better questions about comparison, supplier value and measurement. Check the relevant market, source date and transaction scope before turning an industry announcement into a business assumption.",
  "commissioningContent": "## When should you involve an AI marketing agency?\n\nInvolve an AI marketing agency when the work spans technical discovery, buyer-focused content and a governed operational workflow that your team cannot deliver alone. Agree the decision to improve, the evidence required and the person responsible. Commission a defined piece of work before expanding into a broader B2B marketing program.\n\nFor UK B2B teams, our [AI marketing strategy service](https://integrated.social/services/ai-marketing-strategy/) connects buyer understanding with channel and content priorities. Explore [SEO, AEO and GEO support](https://integrated.social/services/seo-aeo-geo/) for discoverability, or [agentic AI implementation](https://integrated.social/services/gemini-agentic-ai/) for a defined workflow with human oversight.",
  "aliases": {
    "article-tldr-heading": [
      "ai-answer-summary",
      "ai-summary"
    ],
    "what-does-the-expedia-evidence-actually-show": [
      "the-fastest-growing-channel-no-ota-expected"
    ],
    "could-an-ai-agent-bypass-expedia-entirely": [
      "the-agentic-booking-scenario",
      "2-build-the-supply-advantage-that-ai-agents-cannot-easily-replicate",
      "3-expand-b2b-distribution-into-high-frequency-consumer-apps"
    ],
    "how-could-ai-agents-change-shopping-and-travel-comparison": [
      "expedia-s-three-part-response",
      "1-become-the-preferred-source-for-ai-answer-engines"
    ],
    "what-should-b2b-marketing-teams-learn-from-expedia": [
      "what-the-expedia-case-means-for-every-b2b-marketer",
      "the-three-questions-every-b2b-marketer-should-ask"
    ],
    "why-do-technical-seo-and-relevant-copywriting-belong-together": [
      "the-aeo-imperative"
    ]
  },
  "cta": {
    "heading": "Start with an AI visibility baseline",
    "body": "For an initial readiness baseline, check your AI visibility. The free score is separate from a paid diagnostic or implementation engagement.",
    "button": "Check my AI visibility",
    "url": "https://integrated.social/free-ai-growth-audit/"
  }
};
